import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CountriesPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = (count = 5, offset = 0) => {
    apiRequests.countries.get(count, offset).then((res) => setData(res));
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = async (id) => {
    await apiRequests.countries.delete(id).then(() =>
      setData((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.countries.getFiltered(searchValue).then((res) => setData(res));
    }
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск стран..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Валюты', value: item.currencies?.length > 0 ? item.currencies.map(c => c.code).join(', ') : 'Отсутствуют' },
                { label: 'Языки', value: item.languages?.length > 0 ? item.languages.map(l => l.code).join(', ') : 'Отсутствуют' },
                { label: 'Добавлено', value: dateToString(item.createdAt) },
              ]}
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={!item.isDefault ? () => handleDelete(item.id) : null}
            />
          ))
        )}
      </div>
      <Pagination
        count={data.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default CountriesPage;
